<div class="jolojo-ui__flex"
  style:flex-direction={direction}
  style:justify-content={justify}
  style:align-items={align}
  style:flex-wrap={wrap}
  style:gap={`var(--jolojo-ui-${gap}-gap)`}
  style:padding={`var(--jolojo-ui-${padding}-padding)`}
  style:width={width}
  style:height={height}
  style={style}
>
  <slot />
</div>

<script>
  export let direction = 'row'
  export let justify = 'start'
  export let align = 'start'
  export let wrap = 'nowrap'
  export let gap = 'sm'
  export let padding = ''
  export let style = ''
  export let width = ''
  export let height = ''
</script>

<style>
  .jolojo-ui__flex {
    display: flex;
  }

</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>